// podcast 元件 (podcast 列表頁、專題內容頁 )
import { useDispatch, useSelector } from "react-redux";
import { setPodcastPlayer, popState } from "@/slices/popSlice";
import Image from "next/image";

const PodcastComponent = ({ podcast, t, location = null }) => {
  const dispatch = useDispatch();
  const { podcastPlayer } = useSelector(popState);

  // 處理日期
  const handleDate = (date) => date?.replaceAll("-", ".")?.slice(0, 10);

  // 處理時間
  const handleTime = (time) => Math.floor(time / (1000 * 60));

  // 播放或連結跳轉
  const onClick = (podcast) => {
    if (window?.innerWidth > 1023) {
      dispatch(
        setPodcastPlayer({
          trackImg: podcast?.trackImg,
          title: podcast?.title,
          episodeUrl: podcast?.episodeUrl,
          trackId: podcast?.trackId,
        })
      );
    } else {
      window?.open(
        "https://podcasts.apple.com/tw/podcast/id1638302603?i=" +
          podcast?.trackId
      );
    }
  };

  // 專題用
  if (location === "project") {
    return (
      <>
        <div
          className="cp trans w-full max-w-[994px] mx-auto between-center px-[54px] py-[30px] rounded-[4px] border-1 border-black1 bg-white cp
        gap-x-[45px] group hover:bg-black1 blg:px-[10px] ulg:border-0 umd:flex-col umd:gap-y-[10px] bmd:px-[30px] bmd:py-[20px] umd:max-w-[unset]
        usm:!p-0 usm:border-none usm:hover:bg-white"
          onClick={() => onClick(podcast)}
        >
          {/* 圖片 */}
          <div
            className="img-box w-[190px] h-[190px] rounded-[4px] overflow-hidden flex-shrink-0
          umd:w-full umd:max-w-[378px] umd:h-[unset] umd:mx-auto umd:aspect-[378/321]"
          >
            <Image
              width={190}
              height={190}
              src={podcast?.trackImg}
              alt={podcast?.title}
              sizes="160px"
              loading="lazy"
            />
          </div>
          <div className="space-y-[20px] flex-grow w-full">
            {/* 標題 */}
            <h3 className="text-bd2b text-black hover-text">
              {podcast?.title}
            </h3>

            {/* 內文 */}
            <h4 className="text-bd1m text-black9 line-clamp-2">
              {podcast?.summary}
            </h4>

            {/* 時數 發布時間 */}
            <div className="text-bd4n text-black9 flex items-center">
              <div className="img-box w-[30px] h-[30px] after:content-[none] hidden umd:block mr-[14px]">
                <Image
                  width={30}
                  height={30}
                  className="!object-contain dark:filter-white dark:opacity-[.6]"
                  src="/images/icon/icon_play.svg"
                  alt="play_button"
                  loading="lazy"
                />
              </div>
              <Image
                className="relative bottom-[1px]"
                src="/images/icon/icon_audio.svg"
                width={14}
                height={14}
                alt="listen"
                loading="lazy"
              />
              <span className="inline-block ml-[5px] mr-[14px]">
                {handleTime(podcast?.trackTimeMillis)}
                {t("MINUTE")}
              </span>
              <span>{handleDate(podcast?.releasedTime)}</span>
            </div>
          </div>
          {/* 播放鍵 */}
          <button className="img-box w-[34px] h-[34px] after:content-[none] umd:hidden dark:filter-white dark:opacity-[.7]">
            <Image
              width={34}
              height={34}
              className="!object-contain"
              src={`/images/icon/icon_${
                podcastPlayer?.episodeUrl === podcast?.episodeUrl
                  ? "pause"
                  : "play"
              }.svg`}
              alt="play_button"
              loading="lazy"
            />
          </button>
        </div>
      </>
    );
  }

  // podcast頁面用
  return (
    <div
      className="cp group flex items-center gap-x-[35px] w-full umd:flex-col umd:gap-y-[12px]"
      onClick={() => onClick(podcast)}
    >
      <div
        className="img-box w-[320px] aspect-[1/1] rounded-[4px] overflow-hidden flex-shrink-0
      umd:w-full"
      >
        {/* 圖片 */}
        <Image
          className="hover-img"
          width={320}
          height={320}
          src={podcast?.trackImg || "/images/podcast/default_podcast.png"}
          alt={podcast?.title}
          sizes="300px"
        />
      </div>

      <div className="space-y-[15px] umd:space-y-[12px] w-full">
        <div className="flex items-center gap-x-[5px]">
          <div className="img-box w-[14px] h-[14px] after:content-none">
            <Image
              sizes="14px"
              width={14}
              height={14}
              src="/images/icon/icon_audio.svg"
              alt="立即收聽"
            />
          </div>

          <span className="text-bd4n text-black7 7">
            {handleTime(podcast?.trackTimeMillis)}
            {t("MINUTE")}
          </span>
        </div>

        {/* 標題 */}
        <h2 className="text-bd5b text-black line-clamp-3 hover-text umd:line-clamp-[unset] umd:text-bd2b">
          {podcast?.title}
        </h2>

        {/* 摘要 */}
        <h3 className="text-bd4n text-black8 8 line-clamp-3 leading-[180%] umd:line-clamp-2">
          {podcast?.summary}
        </h3>

        <p className="between-center">
          <button
            className={`center-center py-[4px] px-[10px] space-x-[6px] rounded-[2px] trans
          group-hover:bg-pale ${
            podcastPlayer?.trackId === podcast?.trackId
              ? "bg-pale"
              : "bg-jblack"
          }`}
          >
            <span className="img-bpx w-[14px] h-[14px] after:content-none">
              <Image
                className="trans filter-white dark:filter-black dark:group-hover:filter-white"
                width={14}
                height={14}
                src="/images/icon/icon_play.svg"
                alt="play_button"
              />
            </span>
            <span className="trans text-white text-bd3n dark:group-hover:!text-[#fff]">
              {podcastPlayer?.trackId === podcast?.trackId
                ? "播放中"
                : t("LISTEN")}
            </span>
          </button>
          <span className="text-bd4n text-black6">
            {handleDate(podcast?.releasedTime)}
          </span>
        </p>
      </div>
    </div>
  );
};

export default PodcastComponent;
